import script from "./session-time-out.vue?vue&type=script&setup=true&lang=js"
export * from "./session-time-out.vue?vue&type=script&setup=true&lang=js"

import "./session-time-out.vue?vue&type=style&index=0&id=03c01f5e&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c01f5e"]])

export default __exports__